import APIService from '@/services/APIService';

export default {
  getBdgdVersao(bdgdId) {
    return APIService.apiCall().get(`/extracoes-bdgd/${bdgdId}`);
  },

  getDatabaseStructure(bdgdId) {
    return APIService.apiCall().get(`/extracoes-bdgd/${bdgdId}/database-structure`);
  },

  getQueryData(bdgdId, query) {
    return APIService.apiCall().post(`/extracoes-bdgd/${bdgdId}/query-data`, { query });
  },

  getCountRows(bdgdId, pathTable) {
    return APIService.apiCall().get(`/extracoes-bdgd/${bdgdId}/count-rows`, {
      params: { tabela: pathTable }
    });
  },

  save(payload) {
    return APIService.apiCall().post(`/extracoes-bdgd/save`, payload);
  },

  baixarExtracao(extracaoId, config = {}) {
    return APIService.apiCall().get(`/extracoes-bdgd/download/${extracaoId}`, {
      responseType: 'blob',
      ...config
    });
  },

  getAllExtracoes(bdgdId, entidade = '') {
    return APIService.apiCall().get(`/extracoes-bdgd/${bdgdId}/extracoes`, {
      params: entidade ? { entidade } : {}
    });
  }
};
